import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NewPasswordContainer from '../new-password/NewPasswordContainer';
import WorkflowNavContainer from '../workflow-navigation/WorkflowNavContainer';

const propTypes = {
    validatePasswordUrl: PropTypes.string.isRequired,
    defaultPassword: PropTypes.string,
    errorMessage: PropTypes.array,
    workflowNavElementId: PropTypes.string
};

const defaultProps = {
    errorMessage: []
};

class ForgotPasswordContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passwordIsValid: false
        };
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
    }

    handlePasswordChange(isValid) {
        this.setState({ passwordIsValid: isValid });
    }

    render() {
        var errors = this.props.errorMessage.map((err, index) => (
            <div key={index} className="is-warning">
                <p id="error-message" className="asc-form-help">
                    {err.ErrorMessage}
                </p>
            </div>
        ));

        return (
            <div>
                <NewPasswordContainer
                    validateUrl={this.props.validatePasswordUrl}
                    defaultPassword={this.props.defaultPassword}
                    onChange={this.handlePasswordChange}
                />
                {errors}
                <WorkflowNavContainer
                    primaryButtonSubmitEnabled={this.state.passwordIsValid}
                    elementId={this.props.workflowNavElementId}
                />
            </div>
        );
    }
}

ForgotPasswordContainer.propTypes = propTypes;
ForgotPasswordContainer.defaultProps = defaultProps;
export default ForgotPasswordContainer;
